import { useNavigate } from 'react-router';
import Styles from './ErrorPage.module.scss';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DobButton } from '@dedalusdiit/dob-components';

const ErrorPage = (): React.ReactElement => {
    const { errorPage, errorPageInfo } = Styles;
    const navigate = useNavigate();
    const { t } = useTranslation();

    const navigateDashboard = (): void => {
        navigate('/dashboard');
    };

    return (
        <div className={errorPage}>
            <div className={errorPageInfo}>
                <Typography variant="h2">Oops</Typography>
                <Typography variant="body1">{t('SomethingWentWrong')}</Typography>
                <DobButton
                    color="danger"
                    outline
                    onClick={navigateDashboard}
                    size="small"
                >{t('GoBackTo')} dashboard
                </DobButton>
            </div>
        </div>
    );
};

export default ErrorPage;
